import moment from 'moment';
import React, { useState } from 'react';
import { DateInput } from '.';
import TextLabel from './TextLabel';

const CompetenciaInput = ({
  id,
  name,

  required,
  readOnly,

  label,
  format = 'DD/MM/YYYY',
  fullWidth,
  disableFuture,

  value,

  onChange,
  onBlur,

  touched,
  error,
  helperText = 'Campo é obrigatório',
  autoFocus,
  minDate,
  disabled,
}) => {
  const [dataCompetencia, setDataCompetencia] = useState(value);

  if (readOnly) {
    return <TextLabel disabled id={id} label={label} value={value ? moment(value).format(format) : ''} />;
  }

  const handleChange = (_) => {
    const dateMoment = _.target?.value;
    if (!dateMoment) {
      onChange(_);
      return;
    }
    if (dateMoment.isValid()) {
      onChange({ target: { id, value: dateMoment } });
      setDataCompetencia(dateMoment);
    } else {
      onChange(_);
    }
  };

  return (
    <DateInput
      required={required}
      name={name}
      fullWidth={fullWidth}
      id={id}
      label={label}
      value={dataCompetencia}
      onChange={handleChange}
      onBlur={onBlur}
      touched={touched}
      error={error}
      helperText={helperText}
      disabled={disabled}
      format={format}
      disableFuture={disableFuture}
      minDate={minDate}
      autoFocus={autoFocus}
      views={['year', 'month']}
      openTo="month"
    />
  );
};

export default CompetenciaInput;
